import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import classes from "./AdminSidebar.module.scss";
import logo from "./../../../assets/icons/new/04-logo-white.png";
import AdminHeaderLink from "../AdminHeader/AdminHeaderLink/AdminHeaderLink";
import AdminHeaderStatus from "../AdminHeader/AdminHeaderStatus/AdminHeaderStatus";

// *** icons ***
import CampaignIcon from "./../../../assets/icons/components/CampaignIcon";
import DriveIcon from "./../../../assets/icons/components/DriveIcon";
import TeamIcon from "./../../../assets/icons/components/TeamIcon";
import ProductionIcon from "./../../../assets/icons/components/ProductionIcon";
import FixListIcon from "./../../../assets/icons/components/FixListIcon";
import CommunicationIcon from "../../../assets/icons/components/CommunicationIcon";

import { boxiPrimary } from "../../../assets/style/colors";

import { useDispatch, useSelector } from "react-redux";
import { toggleSidebar } from "../../../store/actions/layoutActions";

import AlgoliaSearch from "../../general/AlgoliaSearch/AlgoliaSearch";
import SearchIcon from '@mui/icons-material/Search';
import KeyboardCommandKeyIcon from '@mui/icons-material/KeyboardCommandKey';
import SpaceBarIcon from '@mui/icons-material/SpaceBar';

const AdminSidebar = () => {

  const dispatch = useDispatch();
  const isSidebarOpen = useSelector(state => state.layoutReducer.isSidebarOpen)
  const [platform, setPlatform] = useState(null);  
  
  const [instantSearchOpen, openInstantSearch] = useState(false);
  const [keyCombinationActive, setKeyCombinationActive] = useState(false);
  

  const userName = localStorage.getItem("name").replaceAll('\"', '');

  const isUser = parseInt(localStorage.getItem("role"))===2;
  const userRole = parseInt(localStorage.getItem("role"));
  const advertiseDropdownOptions = [
    {
      name: 'Client Users',
      path: '/dashboard/admin/advertise/user'
    },
    {
      name: 'Backdate Selection',
      path: '/dashboard/admin/advertise/backdate/placeholders'
    }
  ]

  const driveDropdownOptions = [
    {
      name: 'Macros',
      path: '/dashboard/admin/drive/macro'
    },
    {
      name: 'Payments',
      path: '/dashboard/admin/drive/payments'
    }
  ]

  const productionDropdownOptions = [
    {
      name: 'Removals',
      path: '/dashboard/admin/production/removals'
    },
    {
      name: 'Available Inventory',
      path: '/dashboard/admin/production/inventory'
    }
  ]

  useEffect(() => {
    console.log(isSidebarOpen);
  }, [isSidebarOpen])


  const toggle = () => {
    dispatch({type: "TOGGLE_SIDEBAR"})
  }


  useEffect(() => {
    setPlatform(navigator.userAgent.indexOf('Mac') !== -1 ? 'Mac' : 'Windows')
  }, [])

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.code === 'ControlLeft' || event.code === 'MetaLeft') {
        setKeyCombinationActive(true);
      }
      if (event.code === 'ShiftLeft') {
        setKeyCombinationActive(true);
      }
      if (event.code === 'Space' && keyCombinationActive) {
        togglePopup();
      }
    };

    const handleKeyUp = (event) => {
      if (event.code === 'ControlLeft' || event.code === 'MetaLeft') {
        setKeyCombinationActive(false);
      }
      if (event.code === 'ShiftLeft') {
        setKeyCombinationActive(false);
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    document.addEventListener('keyup', handleKeyUp);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('keyup', handleKeyUp);
    };
  }, [keyCombinationActive]);


  const togglePopup = () => {
    openInstantSearch(!instantSearchOpen)
  }

  return (
    <div className={isSidebarOpen ? classes.adminSidebar : classes.adminSidebarClose}>
      <Link to="/dashboard/admin">
        <img className={classes.logo} src={logo} alt-text="Boxi Logo" alt="Boxi Logo" />
      </Link>
      <AdminHeaderStatus>Welcome,{<br />}{userName}</AdminHeaderStatus>
        {userRole === 5 ? (
          <div className={classes.sidebarLinkWrapper}>
          <AdminHeaderLink path="/dashboard/admin/communication" activeIcon={<CommunicationIcon color={boxiPrimary} />} iconHeight={21} iconWidth={21} inactiveIcon={<CommunicationIcon color='#fff' />} disabled={isUser}>Communication</AdminHeaderLink>
          </div>
        ) : userRole === 2 ? (
          <div className={classes.sidebarLinkWrapper}>
            <AdminHeaderLink path="/dashboard/admin/drive" activeIcon={<DriveIcon color={boxiPrimary} />} iconHeight={20} iconWidth={20} inactiveIcon={<DriveIcon color='#fff' />} dropdownOptions={driveDropdownOptions}>Drive</AdminHeaderLink>
            <AdminHeaderLink path="/dashboard/admin/communication" activeIcon={<CommunicationIcon color={boxiPrimary} />} iconHeight={21} iconWidth={21} inactiveIcon={<CommunicationIcon color='#fff' />}>Communication</AdminHeaderLink>
            <AdminHeaderLink path="/dashboard/admin/production" activeIcon={<ProductionIcon color={boxiPrimary} />} iconHeight={15} iconWidth={15} inactiveIcon={<ProductionIcon color='#fff' />} dropdownOptions={productionDropdownOptions}>Production</AdminHeaderLink>
            <AdminHeaderLink path="/dashboard/admin/fixlist" activeIcon={<FixListIcon color={boxiPrimary} />} iconHeight={15} iconWidth={15} inactiveIcon={<FixListIcon color='#fff' />}>Fix List</AdminHeaderLink>
            <AdminHeaderLink path="/dashboard/admin/team" activeIcon={<TeamIcon color={boxiPrimary} />} iconHeight={21} iconWidth={21} inactiveIcon={<TeamIcon color='#fff' />}>Boxi Team</AdminHeaderLink>
          </div>
        ) : (
          <div className={classes.sidebarLinkWrapper}>
          
        <AdminHeaderLink path="/dashboard/admin/advertise" activeIcon={<CampaignIcon color={boxiPrimary} />} iconHeight={13} iconWidth={13} inactiveIcon={<CampaignIcon color='#fff' />} disabled={isUser} dropdownOptions={advertiseDropdownOptions}>
          Advertise
        </AdminHeaderLink>
        <AdminHeaderLink path="/dashboard/admin/drive" activeIcon={<DriveIcon color={boxiPrimary} />} iconHeight={20} iconWidth={20} inactiveIcon={<DriveIcon color='#fff' />} dropdownOptions={driveDropdownOptions}>Drive</AdminHeaderLink>
        <AdminHeaderLink path="/dashboard/admin/communication" activeIcon={<CommunicationIcon color={boxiPrimary} />} iconHeight={21} iconWidth={21} inactiveIcon={<CommunicationIcon color='#fff' />} disabled={isUser}>Communication</AdminHeaderLink>
        <AdminHeaderLink path="/dashboard/admin/production" activeIcon={<ProductionIcon color={boxiPrimary} />} iconHeight={15} iconWidth={15} inactiveIcon={<ProductionIcon color='#fff' />} dropdownOptions={productionDropdownOptions}>Production</AdminHeaderLink>
        <AdminHeaderLink path="/dashboard/admin/fixlist" activeIcon={<FixListIcon color={boxiPrimary} />} iconHeight={15} iconWidth={15} inactiveIcon={<FixListIcon color='#fff' />}>Fix List</AdminHeaderLink>
        <AdminHeaderLink path="/dashboard/admin/team" activeIcon={<TeamIcon color={boxiPrimary} />} iconHeight={21} iconWidth={21} inactiveIcon={<TeamIcon color='#fff' />} disabled={isUser}>Boxi Team</AdminHeaderLink>
      </div>
        )}
      <div className={classes.bottomDivContainer}>
        <div className={classes.bottomDiv}>
          <div className={classes.searchWrapper}>
            <SearchIcon onClick={togglePopup} className={classes.searchIcon} />
          </div>
          <AdminHeaderLink isLogoutButton={true} path="/dashboard/logout">Log Out</AdminHeaderLink>
        </div>
      </div>
      <AlgoliaSearch togglePopup={togglePopup} instantSearchOpen={instantSearchOpen} />
    </div>
  );
};

export default AdminSidebar;
